export class CoinRecord {
    constructor(
        public id: any = '',
        public created_at: Date = new Date(),
        public record_type: string = '',
        public sent_from: string = '',
        public sent_to: string = '',
        public amount: number = 0,
        public display_sent_from?: string | null,
        public task_id?: string | null,
    ) { }
}
